var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.pageRoot,
    { tag: "component", style: _setup.colorVarStyles },
    [
      _c(_setup.LpuStaffAdmin),
      _vm._v(" "),
      _setup.ff_lpu_branding_page_v4 && !_setup.isMobile
        ? _c(_setup.CoreBread, { attrs: { items: _setup.breadcrumbs } })
        : _vm._e(),
      _vm._v(" "),
      _setup.ff_lpu_branding_page_v4
        ? _c(
            "div",
            { staticClass: "d-flex flex-column container" },
            [
              _c(_setup.PetitionBanner, {
                attrs: { "root-class": _setup.isMobile ? "mb-4 px-3" : "mb-6" },
              }),
              _vm._v(" "),
              _c(_setup.AwardBanner, {
                class: { "pb-4 mt-n3": _setup.isMobile },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "lpu-branding position-relative",
          class: {
            container: _setup.ff_lpu_branding_page_v4,
            "lpu-branding--mobile": _setup.isMobile,
            "mb-5": _setup.ff_lpu_branding_page_v4 && !_setup.isMobile,
            "pt-4": _setup.ff_lpu_branding_page_v4 && _setup.isMobile,
          },
          style: _setup.ff_lpu_branding_page_v4
            ? undefined
            : _setup.colorVarStyles,
          attrs: {
            "data-qa": "lpu_page",
            itemtype: "https://schema.org/LocalBusiness",
            itemscope: "",
          },
        },
        [
          _setup.ff_lpu_branding_page_v4
            ? _c("meta", {
                attrs: { itemprop: "name", content: _setup.lpuName },
              })
            : _vm._e(),
          _vm._v(" "),
          _setup.ff_lpu_branding_page_v4 &&
          _setup.localBusinessItemprops.telephone
            ? _c("meta", {
                attrs: {
                  itemprop: "telephone",
                  content: _setup.localBusinessItemprops.telephone,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _setup.ff_lpu_branding_page_v4 &&
          (_setup.localBusinessItemprops.addressLocality ||
            _setup.localBusinessItemprops.streetAddress)
            ? _c(
                "span",
                {
                  attrs: {
                    itemprop: "address",
                    itemscope: "",
                    itemtype: "https://schema.org/PostalAddress",
                  },
                },
                [
                  _setup.localBusinessItemprops.addressLocality
                    ? _c("meta", {
                        attrs: {
                          itemprop: "addressLocality",
                          content:
                            _setup.localBusinessItemprops.addressLocality,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _setup.localBusinessItemprops.streetAddress
                    ? _c("meta", {
                        attrs: {
                          itemprop: "streetAddress",
                          content: _setup.localBusinessItemprops.streetAddress,
                        },
                      })
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _setup.ff_lpu_branding_page_v4 &&
          _setup.localBusinessItemprops.priceRange
            ? _c("meta", {
                attrs: {
                  itemprop: "priceRange",
                  content: _setup.localBusinessItemprops.priceRange,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _setup.ff_lpu_branding_page_v4 && _setup.localBusinessItemprops.logo
            ? _c("meta", {
                attrs: {
                  itemprop: "logo",
                  content: _setup.localBusinessItemprops.logo,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _setup.context.request.feature_flags.ff_lpu_branding_page_v2 &&
          _setup.context.is_lpu_branding_preview
            ? _c(_setup.PreviewMenu, {
                class: {
                  "order-first":
                    _setup.context.request.feature_flags
                      .ff_lpu_branding_page_v4,
                },
                attrs: { "lpu-id": _setup.context.lpu.id },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex flex-column ga-6",
              class: _setup.sectionOrder.card,
            },
            [
              _c(_setup.HeroSection, {
                tag: "component",
                attrs: {
                  lpu: _setup.context.lpu,
                  "lpu-branding": _setup.context.lpu_branding,
                  "lpu-video-card": _setup.context.lpu_video_card,
                  "synonym-prices-count": _setup.context.synonym_prices_count,
                },
              }),
              _vm._v(" "),
              _setup.context.request.feature_flags.ff_lpu_branding_page_v2
                ? _c(_setup.SectionMenu, {
                    attrs: {
                      lpu: _setup.context.lpu,
                      "synonym-prices-count":
                        _setup.context.synonym_prices_count,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _setup.context.request.feature_flags.ff_lpu_branding_page_v2
            ? [
                _setup.context.request.feature_flags.ff_lpu_branding_page_v4
                  ? [
                      _setup.context.lpu_branding?.banners?.length
                        ? _c(_setup.LpuBanners, {
                            class: _setup.sectionOrder.banners,
                            attrs: {
                              banners: _setup.context.lpu_branding.banners,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _setup.context.lpu_branding?.categories?.length
                        ? _c(_setup.LpuSpecializations, {
                            class: _setup.sectionOrder.specializations,
                            attrs: {
                              specializations:
                                _setup.context.lpu_branding.categories,
                              lpu: _setup.context.lpu,
                            },
                          })
                        : _vm._e(),
                    ]
                  : _setup.context.lpu_branding?.banners?.length ||
                    _setup.context.lpu_branding?.categories?.length
                  ? _c(
                      "div",
                      { staticClass: "d-flex flex-column gr-8" },
                      [
                        _setup.context.lpu_branding?.banners?.length
                          ? _c(_setup.LpuBanners, {
                              attrs: {
                                banners: _setup.context.lpu_branding.banners,
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _setup.context.lpu_branding?.categories?.length
                          ? _c(_setup.LpuSpecializations, {
                              attrs: {
                                specializations:
                                  _setup.context.lpu_branding.categories,
                                lpu: _setup.context.lpu,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _setup.context.lpu_branding?.advantages?.length
                  ? _c(_setup.LpuAdvantages, {
                      class: _setup.sectionOrder.advantages,
                      attrs: {
                        advantages: _setup.context.lpu_branding?.advantages,
                        "video-url":
                          _setup.context.lpu_video_card?.video_path?.url,
                        "video-uuid": _setup.context.lpu_video_card?.uuid,
                        "preview-url":
                          _setup.context.lpu_video_card?.preview_path?.url,
                      },
                    })
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm._v(" "),
          _setup.context.request.feature_flags.ff_lpu_branding_page_v3
            ? [
                _setup.context.lpu_information
                  ? _c(_setup.LpuFeatures, {
                      class: _setup.sectionOrder.features,
                      attrs: {
                        "lpu-information": _setup.context.lpu_information,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(_setup.LpuDoctorsList, {
                  class: _setup.sectionOrder.doctors,
                  attrs: { lpu: _setup.context.lpu },
                }),
                _vm._v(" "),
                _setup.context.lpu.appointment_on &&
                _setup.context.lpu.has_slots
                  ? _c(_setup.LpuDoctorsSchedule, {
                      class: _setup.sectionOrder.work_schedule,
                      attrs: { lpu: _setup.context.lpu },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _setup.showRatingSection
                  ? _c(_setup.LpuRating, {
                      class: _setup.sectionOrder.rating_and_rates,
                      attrs: { lpu: _setup.context.lpu },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(_setup.LpuReviews, {
                  class: _setup.sectionOrder.rating_and_rates,
                  attrs: { lpu: _setup.context.lpu },
                }),
                _vm._v(" "),
                _c(_setup.LpuPromotions, {
                  class: _setup.sectionOrder.promotions,
                  attrs: { lpu: _setup.context.lpu },
                }),
                _vm._v(" "),
                _c(_setup.LpuPrices, {
                  class: _setup.sectionOrder.prices,
                  attrs: { lpu: _setup.context.lpu },
                }),
                _vm._v(" "),
                _c(_setup.LpuInformation, {
                  class: _setup.sectionOrder.gallery,
                  attrs: {
                    lpu: _setup.context.lpu,
                    "lpu-information": _setup.context.lpu_information,
                  },
                }),
                _vm._v(" "),
                _setup.context.lpu.lpu_documents?.length
                  ? _c(_setup.LpuDocuments, {
                      class: _setup.sectionOrder.documents,
                      attrs: {
                        documents: _setup.context.lpu.lpu_documents,
                        "lpu-name": _setup.context.lpu.name,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _setup.context.related_lpus?.length
                  ? _c(_setup.LpuRelatedClinics, {
                      class: _setup.sectionOrder.related_clinics,
                      attrs: { items: _setup.context.related_lpus },
                    })
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm._v(" "),
          _setup.context.request.feature_flags.ff_lpu_branding_page_v4
            ? [
                _c(_setup.LpuPhonebook, {
                  class: _setup.sectionOrder.phone_directory,
                }),
                _vm._v(" "),
                _c(_setup.LpuInterview, {
                  class: _setup.sectionOrder.manager_interview,
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(_setup.CoreSnackbar),
          _vm._v(" "),
          _setup.ff_lpu_branding_page_v4
            ? _c("meta", {
                attrs: { itemprop: "url", content: _setup.itempropUrl },
              })
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _setup.ff_lpu_branding_page_v4 && _setup.isMobile
        ? _c(_setup.BreadcrumbsJsonLd, {
            attrs: { json: _setup.breadcrumbsJsonLd },
          })
        : _vm._e(),
      _vm._v(" "),
      _setup.ff_lpu_branding_page_v4
        ? _c(_setup.BreadcrumbsJsonLd, {
            attrs: { json: _setup.localBusinessJsonLd },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(_setup.LpuPopupMap),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }